import { AuthConfig } from 'angular-oauth2-oidc';

// for local testing
// export const authCodeFlowConfig: AuthConfig = {
//   issuer: 'http://localhost:8092/auth',
//   redirectUri: 'http://localhost:8080/gui/callback',
//   postLogoutRedirectUri: 'http://localhost:8080/',
//   clientId: 'gui-client',
//   responseType: 'code',
//   scope: 'openid profile email offline_access',
//   // showDebugInformation: true,
//   // oidc: true,
//   requireHttps: false
// };

// for orange connect
export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://auth.tech.orange',
  redirectUri: 'https://sso-validation.di-generateit.tech.orange/callback',
  postLogoutRedirectUri: 'https://sso-validation.di-generateit.tech.orange/callback',
  clientId: 'rp-di-generit',
  responseType: 'code',
  scope: 'openid profile email offline_access',
  oidc: true
};
